import { GetStaticProps } from 'next';
import React, { useEffect } from 'react';
import { MetaTagsComp } from '../components/MetaTagsComp';
import Testpreps from '../components/TestPreparation';
import fetchUtil from '../utils/fetchUtil';

const Testprep: React.FC = (props: any) => {
  const { meta } = props.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6C48F0');
    customStyle.setProperty('--navbar-menu-color', '#ffffff')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <Testpreps {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/test-preparation`, 'GET', {}, '', false)
  return {
    props: {
      pageData,
    }
  };
}

export default Testprep;